module.exports = __webpack_public_path__ + "static/img/Gradient2.b566d56e.png";